import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/switching/compact/pro-8-poe.png";
import type { Product } from "../../types";
import { switchingCompact } from "../product-list-groups/switchingCompact";
import {
  downlinkSpeed,
  etherlighting,
  mounting,
  outdoorReady,
  poeAvailability,
  poeOutput,
  portCount,
  ports,
  powerMethod,
  proAvSupport,
  switchTechnology,
  uplinkSpeed,
} from "../properties";

export const professional8PoE: Product = {
  id: "professional8PoE",
  productTitle: "Pro 8 PoE",
  techspecsPath: [SiteId.TechSpecs, "/unifi/switching/usw-pro-8-poe"],
  storePathParts: {
    productSlug: "usw-pro-8-poe",
    category: "switching-utility",
  },
  sku: "USW-Pro-8-PoE",
  description: "professional8PoE.description",
  descriptionMaxWidth: 150,
  image: { src: image, width: 200, height: 140 },
  productListGroup: switchingCompact,
  propertyValues: [
    {
      propertyId: "dimensions",
      value: {
        type: "string",
        value: '200 x 248 x 44 mm\n(7.9 x 9.8 x 1.7")',
      },
    },
    {
      propertyId: switchTechnology.id,
      value: {
        type: "translation",
        value: "commons.switchingTechnology.layer2",
      },
    },
    {
      propertyId: portCount.id,
      value: { type: "string", value: "8" },
    },
    {
      propertyId: ports.id,
      value: {
        type: "string",
        value: "(10) GbE RJ45\n(2) 10G SFP+",
      },
    },
    {
      propertyId: downlinkSpeed.id,
      value: { type: "string", value: "1 Gbps" },
    },
    {
      propertyId: uplinkSpeed.id,
      value: { type: "string", value: "10 Gbps" },
    },
    {
      propertyId: poeOutput.id,
      value: {
        type: "translation",
        value: "commons.poeOutput.upToPoe++",
      },
    },
    {
      propertyId: poeAvailability.id,
      value: { type: "string", value: "120 W" },
    },
    {
      propertyId: etherlighting.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: proAvSupport.id,
      value: { type: "boolean", value: false },
    },

    {
      propertyId: "generalRedundancy",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: powerMethod.id,
      value: {
        type: "translation",
        value: "commons.powerMethod.acPower",
      },
    },
    {
      propertyId: mounting.id,
      value: {
        type: "translation",
        value: "commons.mounting.desktopWall",
      },
    },
    {
      propertyId: outdoorReady.id,
      value: { type: "boolean", value: false },
    },
  ],
};
